export default function () {

    $("#clear-button").click(function () {
        $("#venue").val("");
    });

    let input = document.getElementById('venue');
    let options = {
        types: ['establishment']
    };

    if (window?.google) {

        let autocomplete = new google.maps.places.Autocomplete(input, options);

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            let place = autocomplete.getPlace();
            if (!place.geometry) {
                console.log("Place details not available for input: '" + place.name + "'");
                return;
            }


            if (place.address_components) {

                let formattedFullAddress = [];

                for (let i = 0; i < place.address_components.length; i++) {

                    let component = place.address_components[i];

                    if (component.types.includes('street_number')) {
                        formattedFullAddress[0] = component.long_name;
                    } else if (component.types.includes('route')) {
                        formattedFullAddress[1] = " " + component.long_name;
                    } else if (component.types.includes('subpremise')) {
                        formattedFullAddress[3] = ", " + component.long_name;
                    }
                }

                $('#address').val(formattedFullAddress.join(''));
            }

            for (let i = 0; i < place.address_components.length; i++) {

                let component = place.address_components[i];

                if (component.types.includes('locality')) {
                    $('#city').val(component.long_name);
                } else if (component.types.includes('postal_code')) {
                    $('#zip').val(component.long_name);
                }
            }
        });
    }
}
